/**
 * Platform Detector
 * Auto-detects e-commerce platform and returns appropriate adapter
 */

import { BaseAdapter } from './base-adapter';
import { WooCommerceAdapter } from './woocommerce';
import { ShopifyAdapter } from './shopify';
import { GenericAdapter } from './generic';

export class PlatformDetector {
  private debug: boolean;

  constructor(debug: boolean = false) {
    this.debug = debug;
  }

  /**
   * Detect platform and return appropriate adapter
   */
  detect(): BaseAdapter {
    // Try WooCommerce
    const woocommerce = new WooCommerceAdapter(this.debug);
    if (woocommerce.detect()) {
      return woocommerce;
    }

    // Try Shopify
    const shopify = new ShopifyAdapter(this.debug);
    if (shopify.detect()) {
      return shopify;
    }

    // Fallback to generic
    return new GenericAdapter(this.debug);
  }

  /**
   * Detect multiple platforms (for hybrid sites)
   */
  detectAll(): BaseAdapter[] {
    const adapters: BaseAdapter[] = [];

    const woocommerce = new WooCommerceAdapter(this.debug);
    if (woocommerce.detect()) {
      adapters.push(woocommerce);
    }

    const shopify = new ShopifyAdapter(this.debug);
    if (shopify.detect()) {
      adapters.push(shopify);
    }

    // Always add generic as fallback
    adapters.push(new GenericAdapter(this.debug));

    return adapters;
  }

  /**
   * Force specific platform
   */
  force(platform: string): BaseAdapter {
    const platformLower = platform.toLowerCase();

    if (platformLower === 'woocommerce') {
      return new WooCommerceAdapter(this.debug);
    }

    if (platformLower === 'shopify') {
      return new ShopifyAdapter(this.debug);
    }

    return new GenericAdapter(this.debug);
  }
}
